export const PageUrlMappings = {
  HELP_DESK: {
    langKey: 'crm-links.backToPageName.helpDesk',
    // Help desk Default-7 is the spam view
    // /help-desk/45374333/view/96353125/ticket/3101618614
    // /help-desk/45374333/view/DEFAULT-7/thread/7775700855
    // /help-desk/100541147/view/161207557/list-view
    path: /help-desk\/\d+\/view\/(\d+\/ticket\/\d+|DEFAULT-7\/thread\/\d+|\d+\/list-view)/
  },
  SALES_WORKSPACE: {
    langKey: 'crm-links.backToPageName.salesWorkspace',
    // ex: /prospecting/890441285/playlist/tasks/overdue
    // ex: /prospecting/890441285/deals/open
    path: /\/prospecting\/\d+\/.+/
  }
};